import React from 'react';
import './TutorialProgress.css';

interface TutorialProgressProps {
  currentStep: number;
  totalSteps: number;
}

const TutorialProgress: React.FC<TutorialProgressProps> = ({ currentStep, totalSteps }) => {
  const progressPercentage = (currentStep / totalSteps) * 100;

  const getStepLabel = (step: number): string => {
    switch (step) {
      case 1: return 'Willkommen';
      case 2: return 'Einsatztypen';
      case 3: return 'Standorte';
      case 4: return 'Funkkanäle';
      case 5: return 'Aufgaben';
      case 6: return 'Fertig';
      default: return `Schritt ${step}`;
    }
  };

  return (
    <div className="tutorial-progress">
      {/* Progress Bar */}
      <div className="progress-bar">
        <div 
          className="progress-fill"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>

      {/* Step Labels */}
      <div className="step-labels">
        {Array.from({ length: totalSteps }, (_, index) => {
          const stepNumber = index + 1;
          const isActive = stepNumber === currentStep;
          const isCompleted = stepNumber < currentStep;
          
          return (
            <div 
              key={stepNumber}
              className={`step-label ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}
            >
              <div className="step-number">
                {isCompleted ? '✓' : stepNumber}
              </div>
              <span className="step-text">{getStepLabel(stepNumber)}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TutorialProgress;
